export default "<p>syndata works!</p>\n"